import React from 'react';
import { useTranslation } from 'react-i18next';
import { RadioButtons } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Join ({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.JOIN.';
    // Assign radio button values
    const options = {
        radioButtons: {
            data: [{
                    value: 'inner',
                    label: label + 'INNER'
                }, {
                    value: 'left',
                    label: label + 'LEFT'
                }, {
                    value: 'right',
                    label: label + 'RIGHT'
                }, {
                    value: 'full',
                    label: label + 'FULL'
            }],
            defaultValue: 'inner'
        }
    }
    return (
        <div>
            <div className="form-element">
                {t(label + 'FIRST-TABLE')}
                <VariablePicker action={action} inputName="firstTable" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired/>
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'FIRST-COLUMN')}
                <TextInput action={action} inputName="firstColumn" variables={variables} setOpenVariable={setOpenVariable} isRequired/>
            </div>
            <div className="form-element">
                {t(label + 'SECOND-TABLE')}
                <VariablePicker action={action} inputName="secondTable" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired/>
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'SECOND-COLUMN')}
                <TextInput action={action} inputName="secondColumn" variables={variables} setOpenVariable={setOpenVariable} isRequired/>
            </div>
            <div className="form-element">
                {t(label + 'TYPE')}
                <RadioButtons action={action} inputName="openAs" options={options.radioButtons} isRequired/>
            </div>
        </div>
    );
}
export default Join;